<template>
<div class="desk-phone-row" v-if="value">
  <div class="desk-phone-row__header">
    <div class="desk-phone-row__header__left" v-if="showLogo && logo && showImage">
      <img :src="logo" :alt="displayName" @error="handleImageError" />
    </div>
    <div class="desk-phone-row__header__right">
      <div class="desk-phone-row__title">
        <span>{{ displayName }}</span>
        <span>{{ $money(currentAmount) }}</span>
      </div>
      <div class="desk-phone-row__switch-btn-container" v-if="showSwitchBtn">
        <zm-button
          type="link"
          ghost
          @click="handleSwitchSelf"
          :aria-label="'switch ' + displayName">
          {{ $t('billing.hw.desk_phones.switch') }}
        </zm-button>
      </div>
    </div>
  </div>
  <p class="desk-phone-row__desc">{{ $t('billing.hw.desk_phones.config.desk_phone_row.desc') }}</p>
  <div class="desk-phone-row__config-row">
    <input-number-with-popover
      :value="currentLicense"
      @change="handleNumberChange"
      :dataTracking="{
        buyInteraction: 'desk phone',
        buySelection: `desk phone - ${displayName}`
      }"
      size="lg"
      controls-position="both"
      :min="1"
      :max="50"
      :increaseTips="``"
      :decreaseTips="``"
      :unit="uintDesc"
      :label="`${displayName} quantity`"
      :teleport-target="teleportTarget"
      :data-testid="`checkout-input-license-${value ? value.plan_code : ''}`"
    ></input-number-with-popover>

    <zm-button
      v-if="showRemoveBtn"
      type="link"
      ghost
      @click="handleRemoveSelf"
      :aria-label="'remove ' + displayName"
    >{{ $t('billing.common.remove') }}</zm-button>
  </div>
</div>
</template>
<script>
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover.vue';
import { mapMutations } from 'vuex';
import { addUrlParams } from '@/utils';
import { snapImageParams } from '@/plans/ZOOM_DEVICE/constant';

export default {
  name: 'DeskPhoneRow',
  components: { InputNumberWithPopover },
  props: {
    value: {
      type: Object,
      default: () => null
    },
    showRemoveBtn: {
      type: Boolean,
      default: false
    },
    showSwitchBtn: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    teleportTarget: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showImage: true // Control image visibility
    }
  },
  computed: {
    currentLicense() {
      return this.value?.cartInfo?.selected_number || 0
    },
    currentAmount() {
      return (this.value?.amount || 0) * this.currentLicense
    },
    displayName() {
      return `${this.value.planName} ${this.$t(this.value.typeNameKey)}`
    },
    logo() {
      return addUrlParams(this.value?.__originData?.coverImage, snapImageParams);
    },
    uintDesc() {
      return (this.$t('billing.hw.desk_phones.config.desk_phone_row.unit', this.currentLicense));
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan']),

    /**
     * Handle image load error
     * Hide the image when it fails to load
     */
    handleImageError() {
      this.showImage = false;
    },

    handleNumberChange(v) {
      this.updateSelectPlan({
        plan_code: this.value.plan_code,
        cartInfo: { selected_number: v }
      })
    },
    handleRemoveSelf() {
      this.$tracking.buyInteraction('desk phones options', `desk phone - ${this.$tEn(this.value.typeNameKey)} - remove`);
      this.removePlan(this.value.plan_code)
    },
    handleSwitchSelf() {
      this.$emit('switch-desk-phone', this.value);
    }
  }
}
</script>
<style lang="scss">
.desk-phone-row {
  margin-bottom: 24px;

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &__left {
      height: 44px;
      max-width: 50px;
      min-width: 44px;
      margin-right: 12px;
      align-self: center;
      img {
        width: auto;
        min-width: 44px;
        height: 100%;
        object-fit: cover;
      }
    }

    &:has(.desk-phone-row__header__left) {
      margin-bottom: 12px;
    }

    &__right {
      flex: 1;
    }
  }


  &__title {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    /* body/LF — L (R) */
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__desc {
    color: var(--zoom-color-text-neutral, #555B62);
    /* body/LF — S (R) */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */

    margin-top: 0;
    margin-bottom: 24px;
    padding: 0;
  }
  &__config-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
